import { Controller } from '@hotwired/stimulus';
/*
 * Description
 * -------
 *
 * Creates a slider using Glide.js.
 *
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * slidesCount - (required) - number of slides
 *
 * Usage
 * -------
 *
 * <div data-controller="slider" data-slider-slides-count-value="3">
 *   <div data-glide-el="controls">
 *     <button type="button" data-glide-dir=">">Next</button>
 *     <button type="button" data-glide-dir="<">Previous</button>
 *   </div>
 *   <div data-glide-el="track">
 *     <div>
 *       <div>Slide 1</div>
 *       <div>Slide 2</div>
 *       <div>Slide 3</div>
 *     </div>
 *   </div>
 * </div>
 */
export class Slider extends Controller {
    static values = { numberOfSlides: Number };
    async connect() {
        const { default: Glide } = await import('@glidejs/glide');
        new Glide(this.element, {
            type: 'slider',
            perView: 4,
            focusAt: 0,
            startAt: 0,
            bound: true,
            rewind: false,
            keyboard: true,
            gap: 16,
            breakpoints: {
                1024: {
                    perView: 3,
                },
                640: {
                    perView: 2,
                },
            },
            // @ts-ignore
            classes: {
                arrow: {
                    disabled: 'disabled',
                },
            },
        }).mount();
    }
}
